const SUMMARY_URL = 'https://tophamtechbe.com/api/treas/idx/v1/retrieve-property-summary/page';
const FEATURED_LIMIT = 10;

export async function loadFeaturedProperties({ propertyFetch, agentMlsId, officeKey, state }) {
  const load = async (scope) => {
    const params = new URLSearchParams({
      ...scope,
      state,
      status: 'Active',
      priceSort: 'highlow',
      firstPhoto: 'true',
      hasMedia: 'true',
      pageSize: String(FEATURED_LIMIT)
    });
    const response = await propertyFetch(`${SUMMARY_URL}?${params}`);
    if (!response.ok) throw new Error(`Featured properties request failed (${response.status}).`);
    const data = await response.json();
    return data.properties || [];
  };

  // Fetch each scope separately so a higher-priced office listing cannot displace
  // Jeff's own listings. Either scope can still display if the other fails.
  const results = await Promise.allSettled([
    load({ listAgentMlsId: agentMlsId }),
    load({ listOfficeKeyNumeric: officeKey })
  ]);
  if (results.every(result => result.status === 'rejected')) throw results[0].reason;

  const seen = new Set();
  return results.flatMap(result => result.status === 'fulfilled'
    ? [...result.value].sort((a, b) => Number(b.current_price || 0) - Number(a.current_price || 0))
    : [])
    .filter(property => {
      if (!property.listing_key || seen.has(String(property.listing_key))) return false;
      seen.add(String(property.listing_key));
      return true;
    })
    .slice(0, FEATURED_LIMIT);
}
